// Import everything related to article page view
import ShareButtons from "../social/ShareButtons";
import ShareButton from "../social/ShareButton";
// We keep a local min version of this library because the maintainer didn't put any export
import "../lib/universal-parallax.min";
import Tracking from "../analytics/Tracking";
import MediaQueries from "../utils/MediaQueries";
import BrowserDetect from "../utils/BrowserDetect";
import initPictureZoom from "./PictureZoom";
import * as DomUtils from "../utils/DomUtils";
import "../paid-content/PaidContent";

$(function () {
    Tracking.startArticleViewTracking();

    // For Luxtimes articles: set all article items as "fit"
    let luxtimesClass = $(".en");
    // EN articles have a different width/layout than other editions except for Storytelling articles
    let storytellingClass = $(".article-page-content--internal-storytelling"); // we want to keep the item--full for Storytelling intro

    if (storytellingClass.length <= 0 && luxtimesClass.length > 0) {
        $(
            ".article-page-content .article-item--full, " +
                ".article-page-content .article-item--inline, " +
                ".article-page-content .article-item--inline-left," +
                ".article-page-content .article-item--inline-right ," +
                ".article-page-content .article-item--normal, " +
                ".article-page-content .article-item--normal--lg-up, " +
                ".article-page-content .context-box--right," +
                ".article-page-content .context-box--left"
        ).each(function () {
            let articleItem = $(this);
            let articleItemClasses = articleItem.attr("class").split(/\s+/);
            // if it's an inline-left or inline-right picture, we keep it as is. Otherwise, we set item as "fit"
            if (
                !(
                    articleItemClasses.includes("article-picture") &&
                    (articleItemClasses.includes(
                        "article-item--inline-right"
                    ) ||
                        articleItemClasses.includes(
                            "article-item--inline-left"
                        ))
                )
            ) {
                articleItem.removeClass(
                    "article-item--full " +
                        "article-item--normal " +
                        "article-item--inline " +
                        "article-item--inline-right " +
                        "article-item--inline-left " +
                        "article-item--normal--lg-up "
                );
                articleItem.addClass("article-item--fit");
            }
        });
    }

    const initShareButtons = (name, value) => {
        let shareButtonClass = "share__content__item",
            shareButtonsClass = "share-buttons",
            articlePageContentClass = "article-page-content";
        ShareButton.init(articlePageContentClass);
        if (!name || !value) {
            ShareButtons.init(shareButtonsClass);
            ShareButtons.init(shareButtonClass);
        } else {
            ShareButtons.initWithParameter(shareButtonsClass, name, value);
            ShareButtons.initWithParameter(shareButtonClass, name, value);
        }
        ShareButtons.initScroll(shareButtonsClass);
    };

    if (!window.isPreview) {
        // Apply Medium.com zoom effect on pictures
        initPictureZoom();
    }
    window.pym.autoInit();

    // Editor cm link hack
    var cmLink = $("#article-content").data("cm");
    if (cmLink) {
        $(document).on("dblclick", "#article-title", function (e) {
            if (e.shiftKey && e.altKey) {
                var win = window.open(cmLink, "_blank");
                win.focus();
            }
        });
    }

    // Picture gallery support for IE
    if (BrowserDetect.isIe11orBelow()) {
        $(".picture-gallery--grid").addClass("u-hide");
        $(".picture-gallery-container").removeClass("u-hide");
    }

    // Before/after embeds
    Array.from(document.querySelectorAll(".before-after-embed")).forEach(
        (beforeAfterEmbed) => {
            let inkbox = beforeAfterEmbed.querySelector(
                    ".before-after-embed__after"
                ),
                colorbox = beforeAfterEmbed.querySelector(
                    ".before-after-embed__before"
                ),
                fillerImage = beforeAfterEmbed.querySelector(
                    ".before-after-embed__after__img"
                );

            // juxtapose engine
            function trackLocation(e) {
                e.preventDefault();
                var rect = fillerImage.getBoundingClientRect();
                let mousepos = e.pageX;
                if (isNaN(mousepos)) {
                    mousepos = event.targetTouches[0].pageX;
                }
                var position =
                    ((mousepos - rect.left) / fillerImage.offsetWidth) * 100;
                if (position <= 100) {
                    colorbox.style.width = position + "%";
                }
            }

            inkbox.addEventListener("mousemove", trackLocation, false);
            inkbox.addEventListener("touchstart", trackLocation, false);
            inkbox.addEventListener("touchmove", trackLocation, false);
        }
    );

    // parallax effect for Windowed and Fill Screen embed pics
    let parallaxPics = document.querySelectorAll(".parallax");
    if (parallaxPics.length > 0) {
        parallaxPics.forEach((picture) => {
            // If available, apply mobile cropping
            let parallaxImgMobile = picture.getAttribute(
                "data-parallax-image-mobile"
            );
            if (parallaxImgMobile && MediaQueries.isMobile()) {
                picture.setAttribute("data-parallax-image", parallaxImgMobile);
            }
        });
        new window.universalParallax().init({
            speed: 6.0,
        });
    }

    // add video theme
    let specialTheme = DomUtils.getMetadata("specialTheme");
    if (specialTheme) {
        document.body.classList.add(specialTheme);
    }

    const stIframe = document.getElementById("strytl");
    if (stIframe) {
        //storytile inbound
        window.addEventListener("message", (e) => {
            if (e.origin === "https://e.stry.tl") {
                let msg = {};
                try {
                    msg = JSON.parse(e.data);
                } catch (err) {
                    console.log("error parsing strytl event");
                }

                if (msg.initial) {
                    if (
                        msg.event === "update-values" &&
                        msg.data &&
                        msg.data.nextPage
                    ) {
                        const currentPage =
                            Number.parseInt(
                                msg.data.nextPage.replace("-", "")
                            ) + 1;
                        initShareButtons("strytlpage", currentPage);
                    } else {
                        initShareButtons();
                    }
                }
            }
        });
    } else if (!window.isPreview) {
        initShareButtons();
    }
});



// WEBPACK FOOTER //
// ./js/page/ArticlePage.js